import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getStore } from '../store/store';
import type { AsyncItemRegistry } from '../store/schema/AsyncItemRegistry';

export function getAsyncItemRegistry(mailboxInfo: MailboxInfo): AsyncItemRegistry | undefined {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return getStore().registryByAccount.get(accountKey);
}
